import { ProductDisclaimer } from 'product/types/Product'

export const getShowSizeGuideByDisclaimer = (
	disclaimer?: ProductDisclaimer
): boolean => {
	const sizeGuideDisclaimers = {
		[ProductDisclaimer.UpDisclaimer]: false,
		[ProductDisclaimer.DownDisclaimer]: false,
		[ProductDisclaimer.SizeguideDisclaimer]: true,
		[ProductDisclaimer.MaternityDisclaimer]: false,
	}

	return !disclaimer || sizeGuideDisclaimers[disclaimer]
}
